<template>
  <div class="comp-full-loading" v-if="myLoading">
    <div class="loading-anim" v-loading="myLoading"></div>
    <div class="loading-text">{{ title }} {{ point }}</div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: () => {
        return '加载中...';
      }
    },
    loading: {
      type: Boolean,
      default: () => {
        return false;
      }
    },

  },
  data() {
    return {
      myLoading: this.loading,
      point: '',
      pointInterval: null,
    };
  },
  watch: {
    loading(newVal) {
      this.setMyLoading(newVal);
    }
  },
  created() {
    this.init();
  },
  mounted() {
  },
  beforeDestroy() {
    document.body.style.overflow = "auto";
    clearInterval(this.pointInterval);
  },
  methods: {
    init() {
      // this.setMyLoading(false);
    },

    setMyLoading(val) {
      if (val) {
        let pointLen = 1;
        this.pointInterval = setInterval(() => { 
          let curLen = 0; 
          this.point = '';
          while (pointLen >= curLen) 
          { 
            this.point += '。'; 
            curLen++;
            console.log('curLen', curLen);
          }
          pointLen = (pointLen + 1) % 3
          console.log('fcltp', this.point);
          console.log('fcl', pointLen);
					clearInterval(this.pointInterval);
					this.setMyLoading(val);
        }, 500);
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
        clearInterval(this.pointInterval);
      }
      this.myLoading = val;
    },
  },
  
};
</script>

<style lang="scss" scoped>
.comp-full-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-text {
  color: white;
  font-size: 24px;
}

.loading-anim {
  top: -50px;
  left: 20px;
}
</style>